import React from 'react'
import styled, { css,keyframes } from 'styled-components'

interface LoaderProps {
	$absolute?: boolean,
	loaded: boolean,
	message?: string
}

const getInnerSpinners = () => {
	const rows = []

	for (let i = 0; i < 12; i++) {
		rows.push(<SpinnerDiv key={i} rotate={30 * i} $delay={1.1 - i * 0.1} />)
	}

	return rows
}

export const Loader = ({ loaded, message, $absolute }: LoaderProps) => (
	<React.Fragment>
		{!loaded && (
			<Container $absolute={!!$absolute} data-testid="loader">
				<Spinner data-testid="loader-spinner">{getInnerSpinners()}</Spinner>
				{message && <Message data-testid="loader-message">{message}</Message>}
			</Container>
		)}
	</React.Fragment>
)

const Container = styled.div<{ $absolute: boolean }>`
	${(props) =>
		props.$absolute &&
		css`
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 0.8);
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 3;
		`}
`

const Spinner = styled.div`
	color: black;
	text-align: center;
	position: relative;
	margin: auto;
	width: 64px;
	height: 64px;
	padding: 50px;
`

const spinnerKeyframes = keyframes`
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
`

interface SpinnerDivProps {
	$delay: number,
	rotate: number
}

const SpinnerDiv = styled.div<SpinnerDivProps>`
	transform-origin: 32px 32px;
	animation: ${spinnerKeyframes} 1.2s linear infinite;
	transform: rotate(${(props: SpinnerDivProps) => props.rotate}deg);
	animation-delay: -${(props: SpinnerDivProps) => props.$delay}s;

	&:after {
		content: ' ';
		display: block;
		position: absolute;
		top: 3px;
		left: 29px;
		width: 5px;
		height: 14px;
		border-radius: 20%;
		background-color: ${(props) => props.theme.colors.primary.base};
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
	}
`

const Message = styled.div``
